import React, { Component } from 'react'
import styled, { css, injectGlobal, keyframes } from 'styled-components';
import { rgba } from 'polished';
import fetchJSONP from 'fetch-jsonp'
import ScrollMenu from 'react-horizontal-scrolling-menu'
import ReactPlayer from 'react-player'

import { width, media } from '../../styles/utils';
import { container, heading, bgImage, button, bgIcon, hoverState, padding } from "../../styles/global"

import banner from '../../assets/images/instagram-banner.png'
import followOn from '../../assets/images/follow-on-insta.png'

class InstagramFeed extends Component {

    state = {
        posts: []
    }

    componentDidMount() {
        const token ='28359098.b3ec6fd.f8e56991c3c6430993c5ce4fc99a0db8',
        numPosts = 9,
        datakey = 'mwInsta',
        useCaching = false,
        timeToStale = 600 * 100 * 30; //30 mins

        const instagramURL = 'https://api.instagram.com/v1/users/self/media/recent?access_token=' + token + '&count=' + numPosts + '&callback=apiCallback';

        let self = this;
        
        fetchJSONP(instagramURL)
            .then(function(response) {
                return response.json()
            }).then(function(json) {
                self.setState({
                    posts: json.data 
                })
            }).catch(function(ex) {
        })
    }

    navigateToPost = (index) => {
        const { posts } = this.state;

        if (index == 99) {
            window.open(
                'https://www.instagram.com/mamboaustralia/',
                '_blank'
            )
        } else {
            window.open(
                posts[index].link,
                '_blank'
            )
        }

    }

    renderInstagram = () => {
        const { posts } = this.state;

       // console.log('posts',posts);
            
        if (posts) {
            const slides = posts.map((post, i) => {

                let instagramPost;
    
                if (post.type == 'image' || post.type == 'carousel') {
                    instagramPost = (
                        <Image 
                            src={post.images.standard_resolution.url}
                        />
                    )
                }
    
                if (post.type == 'video') {
                    instagramPost = (
                        <ReactPlayer 
                            url={post.videos.standard_resolution.url}
                            controls={false}
                            height={'100%'}
                            width={'100%'}
                            playing={true}
                            loop={true}
                            muted={true}
                        />
                    )
                }
    
                return (
                    <InstagramPost
                        key={i}
                        className={'insta-post'}
                        translate={width.phone() ? -((window.innerWidth * 0.63) - 60) : -50}
                    >
                        {instagramPost}
                        <Overlay/>
                    </InstagramPost>  
                )
            })
    
            if (slides.length > 0) {
    
                // Splice in 'Follow on Insta' post
    
                slides.splice(1, 0, 
                    <InstagramPost
                        key={99}
                        className={'insta-post'}
                        translate={width.phone() ? -((window.innerWidth * 0.63) - 60) : -50}
                    >
                        <Image 
                            src={followOn}
                        />
                        <Overlay/>
                    </InstagramPost> 
                )
    
                return (
                    <Instagram>
                        <Marquee
                            pose={''}
                        />
                        <ScrollMenu
                            data={slides}
                            transition={1}
                            translate={width.phone() ? -((window.innerWidth * 0.63) - 20) : -50}
                            clickWhenDrag={false}
                            onSelect={this.navigateToPost}
                            wheel={false}
                        />
                        <Marquee
                            pose={''}
                        />
                    </Instagram>
                )
            }
        }
	}
    
    render() {
        return (
            <Container>
                {this.renderInstagram()}
            </Container>
        )
    }
}

const Container = styled.div`
    position: relative;
    width: 100%;
`

const Instagram = styled.div`
	width: 100%;
	flex-direction: column;
	margin-bottom: 134px;
	margin-top: 60px;
	overflow: hidden;

	${media.phone`
		margin-top: 0;
		margin-bottom: 50px;
	`}
`

const marqueeLeft = keyframes`
	0% { 
		transform: translateX(0); 
	}

	100% { 
		transform: translateX(-307px); 
	}
`

const marqueeLeftMobile = keyframes`
	0% { 
		transform: translateX(0); 
	}

	100% { 
		transform: translateX(-180px); 
	}
`

const marqueeRight = keyframes`
	0% { 
		transform: translateX(-1000px); 
	}

	100% { 
		transform: translateX(-693px); 
	}
`

const marqueeRightMobile = keyframes`
	0% { 
		transform: translateX(-400px); 
	}

	100% { 
		transform: translateX(-220px); 
	}
`
  
const Marquee = styled.div`
	background-image: url(${banner});
	height: 29px;
	width: 200%;
	${bgIcon}
	background-repeat: repeat-x;
	margin: 38px 0;	
	will-change: transform;
    animation: ${marqueeLeft} 2s linear infinite;
    overflow: visible;

    &:nth-child(3) {
        animation: ${marqueeRight} 2s linear infinite;
    }
	
	${media.phone`
		height: 17px;
		margin: 25px 0;	
        animation: ${marqueeLeftMobile} 2s linear infinite;

        &:nth-child(3) {
            animation: ${marqueeRightMobile} 2s linear infinite;
        }
	`}
`

const Overlay = styled.div`
	position: absolute;
	top: 0;
	right: 0;
	left: 0;
	bottom: 0;
	background: ${rgba('black', 0.3)};
	z-index: 1;
    opacity: 0;
    transition: opacity 0.25s ease;
`


const InstagramPost = styled.div`
	height: 350px;
	width: 350px;
	border: 2px solid black;
	margin-right: 40px;
    background: black;
    cursor: pointer;    
    transform: translateX(-150px);
    position: relative;

    &:hover {
        ${Overlay} {
            opacity: 1;
        }
    }

    ${media.phone`
		width: 69vw;
		height: 69vw;
		margin-right: 15px;
        transform: none;
	`}
`

const Image = styled.div`
	background-image: url(${props => props.src});
	${bgImage}
    height: 100%;
`


export default InstagramFeed;




// WEBPACK FOOTER //
// ./src/components/InstagramFeed/instagramFeed.js